// extracted by mini-css-extract-plugin
export default {"comment":"FavoritesPage_comment__4Mrkg"};